import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Flex } from 'antd';
import dayjs from 'dayjs';

import { MultipleSelect } from '@app/components';
import { DATE_PICKER_FORMAT } from '@app/constants';
import { PF } from '@app/pages/Warehouses/GoodsUnits/data';
import type { FiltersType } from '@app/pages/Warehouses/GoodsUnits/types';
import { getSelectedOptions } from '@app/pages/Warehouses/utils';
const FILTERS = `${PF}_filters`;

const { RangePicker } = DatePicker;

export const Filters: FiltersType = ({
  statesOptions,
  productsOptions,
  warehousesOptions,
  values: { StateIds, ProductIds, WarehouseIds, DateS, DateE },
  disabled,
  onFilterChange,
  skipFilters,
  onSearch,
}) => {
  return (
    <Flex
      className={`${FILTERS}_container`}
      align="flex-start"
      wrap="wrap"
      gap={12}
    >
      <RangePicker
        value={[
          DateS ? dayjs(DateS) : dayjs().subtract(7, 'day'),
          DateE ? dayjs(DateE) : dayjs(),
        ]}
        onChange={(dates) => {
          onFilterChange('DateS', dates?.[0]?.toISOString() || null);
          onFilterChange('DateE', dates?.[1]?.toISOString() || null);
        }}
        className={`${PF}_filters_date`}
        placeholder={['Дата с', 'Дата по']}
        disabled={disabled}
        format={DATE_PICKER_FORMAT}
      />
      <MultipleSelect
        className={`${FILTERS}_select`}
        allOptions={productsOptions}
        selectedOption={getSelectedOptions(productsOptions, ProductIds)}
        setSelectedOptions={(values) => {
          onFilterChange(
            'ProductIds',
            values?.map((option) => Number(option.value))
          );
        }}
        placeholder="Все товары"
        width={200}
        minWidth={200}
        loader={disabled}
      />
      <MultipleSelect
        className={`${FILTERS}_select`}
        allOptions={warehousesOptions}
        selectedOption={getSelectedOptions(warehousesOptions, WarehouseIds)}
        setSelectedOptions={(values) => {
          onFilterChange(
            'WarehouseIds',
            values?.map((option) => Number(option.value))
          );
        }}
        placeholder="Все склады"
        width={200}
        minWidth={200}
        loader={disabled}
      />
      <MultipleSelect
        className={`${FILTERS}_select`}
        allOptions={statesOptions}
        selectedOption={getSelectedOptions(statesOptions, StateIds)}
        setSelectedOptions={(values) => {
          onFilterChange(
            'StateIds',
            values?.map((option) => String(option.value))
          );
        }}
        placeholder="Все состояния"
        width={200}
        minWidth={200}
        loader={disabled}
      />
      <div className={`${PF}_filters_buttons`}>
        <Button
          htmlType="reset"
          onClick={skipFilters}
          className={`${PF}_filters_buttons_item`}
          disabled={disabled}
        >
          <CloseCircleOutlined />
          Сброс
        </Button>
        <Button
          type="primary"
          onClick={onSearch}
          className={`${PF}_filters_buttons_item`}
          disabled={disabled}
        >
          Показать
        </Button>
      </div>
    </Flex>
  );
};
